/// <reference path="../../../app.definition.ts" />

import angular from "angular";
import { Util } from "@common/util";


export class InviteTeamMemberController {

    static $inject = ["$scope",
        "$state",
        "$http",
        "$filter",
        "CacheService",
        "subject",
        "teamMember",
        "$uibModalInstance",
        "ApiAdapterService",
        "PopUpService",
        "$q",
        "$uibModalStack"
    ];

    constructor($scope,
        $state,
        $http,
        $filter,
        CacheService,
        subject,
        teamMember,
        $uibModalInstance,
        ApiAdapterService,
        PopUpService,
        $q,
        $uibModalStack
    ) {

        var inviteTeamMemberVm: any = this;
        inviteTeamMemberVm.subject = {};
        inviteTeamMemberVm.teamMember = {};

        inviteTeamMemberVm.init = () => {
            inviteTeamMemberVm.subject = subject;
            inviteTeamMemberVm.teamMember = teamMember;
        }

        inviteTeamMemberVm.closePopup = () => {
            $uibModalInstance.dismiss();
        }

        // process inviation for suggested member from team action
        inviteTeamMemberVm.processSuggestion = function (send) {
            inviteTeamMemberVm.inviteLoader = true;
            var deferred = $q.defer();
            var redeemPath = "/#/ecare-vault/login?for=teammember&";
            var suggestionToProcess = inviteTeamMemberVm.teamMember;

            ApiAdapterService.processSuggestion(
                inviteTeamMemberVm.subject.subjectId,
                suggestionToProcess.providerIdentity,
                send,
                suggestionToProcess.invitation.token,
                redeemPath,
                suggestionToProcess.invitation.inviteDate,
                suggestionToProcess.invitation.inviterName,
                suggestionToProcess.invitation.userId
            ).then((s) => {
                if (send) {
                    // invited success message
                    var subjectFullName = inviteTeamMemberVm.subject.firstName + ' ' + inviteTeamMemberVm.subject.lastName;
                    var localDate = new Date(inviteTeamMemberVm.subject.birthDate);
                    var localTime = localDate.getTime();
                    var localOffset = localDate.getTimezoneOffset() * 60000;

                    var subjectBirthDate = $filter('date')(new Date(localTime + localOffset), 'MMMM d, yyyy');

                    inviteTeamMemberVm.inviteLoader = false;
                    //PopUpService.openInformationModal("Your invitation has been successfully sent.<br><br>Please let "+suggestionToProcess.firstName+" know the secret code for accepting the invite is "+subjectFullName+"’s birthdate, " + subjectBirthDate).then((s) => {
                    toastr.success(Util.INVITATION_SENT_SUCCESSFULLY, "");
                    $uibModalStack.dismissAll(s);
                    //});
                }
                else {
                    $uibModalInstance.close(send);
                    PopUpService.openInformationModal('Suggestion has been ignored.').then((s) => {
                        $uibModalStack.dismissAll(s);
                    });
                }
                $uibModalInstance.close(send);
                deferred.resolve(send);
            }, (e) => {
                inviteTeamMemberVm.inviteLoader = false;
                deferred.reject(e);
                PopUpService.openInformationModal(e);
            });
            return deferred.promise;
        }

        inviteTeamMemberVm.init();
    }
}


angular.module('eCareVault.common.popUp')
    .controller('InviteTeamMemberController', InviteTeamMemberController);
